import { render, staticRenderFns } from "./FooterYili.vue?vue&type=template&id=3ac8b445&scoped=true&"
import script from "./FooterYili.vue?vue&type=script&lang=js&"
export * from "./FooterYili.vue?vue&type=script&lang=js&"
import style0 from "./FooterYili.vue?vue&type=style&index=0&id=3ac8b445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac8b445",
  null
  
)

export default component.exports